import type { UserListOptions, UserPage, UserRepository } from '#/domain/user/UserRepository'

export class GetUserListUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(
    options: UserListOptions,
    search?: string,
    organizationId?: string,
    showInternal?: boolean,
  ): Promise<UserPage> {
    return this.repository.findAll(options, search, organizationId, showInternal)
  }
}
